import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import classnames from "classnames";

import { TeasersPayoutsService } from "../../utils/api";
import useSort from "../../hooks/useSort";

import Table from "../../ui/Table/Table";

import { payoutStatus, gradeStatus } from "../../constants";
import spaceint2 from "../../utils/spaceint2";
import DateSingle from "../../ui/DateRange/DateSingle";

import { canViewPayoutStatusAll } from "../../utils/perm";
import usePermissions from "../../hooks/usePermissions";

import formatDate from "../../utils/formatDate";

import { teaserListDetail } from "../../utils/urls";

const renderSummaryMoney = ({ summaryInfo, summary }) => (
  <span>{spaceint2(summary[summaryInfo.accessor])} ₽</span>
);

function getPayoutStatus(teaser) {
  if (teaser.payout_status == payoutStatus.penalty) {
    return payoutStatus.penalty;
  }
  if (teaser.grade_status == gradeStatus.notPayed) {
    return payoutStatus.fail;
  }
  if (
    teaser.grade_status == gradeStatus.payed &&
    teaser.payout_status == payoutStatus.success
  ) {
    return payoutStatus.success;
  }
  if (
    teaser.grade_status == gradeStatus.wait &&
    teaser.payout_status == payoutStatus.success
  ) {
    return -1;
  } else {
    return teaser.payout_status;
  }
}

const getStatusName = teaser => {
  const status = getPayoutStatus(teaser);
  return {
    [payoutStatus.success]: "Оплачен",
    [payoutStatus.fail]: "Не оплачен",
    [payoutStatus.penalty]: "Штраф",
    [payoutStatus.edit]: "Ошибка",
    [payoutStatus.wait]: "В процессе",
    [-1]: "Оценка"
  }[status];
};

const getStatusClassName = teaser => {
  const status = getPayoutStatus(teaser);
  return {
    [payoutStatus.success]: "green",
    [payoutStatus.fail]: "",
    [payoutStatus.penalty]: "red",
    [payoutStatus.edit]: "orange",
    [payoutStatus.wait]: "",
    [-1]: ""
  }[status];
};

const columns = [
  {
    title: "Дата",
    accessor: "add_date",
    renderDataCell: ({ data }) => {
      return formatDate(data.add_date);
    }
  },
  {
    title: "Автор",
    dataClassName: "author",
    renderDataCell: ({ data }) => {
      if (data.user) {
        return data.user.name || data.user.id;
      }
    }
  },
  {
    title: "ID",
    accessor: "id",
    renderDataCell: ({ data }) => {
      return (
        <Link target="_blank" to={teaserListDetail(data.id)}>
          {data.id}
        </Link>
      );
    }
  },
  {
    title: "Заголовок",
    className: "table__border-right",
    dataClassName: "table__border-right",
    accessor: "title"
  },
  {
    title: "Статус",
    accessor: "payout_status",
    renderDataCell: ({ data }) => {
      return (
        <span
          className={classnames("page-pay__status", getStatusClassName(data))}
        >
          {getStatusName(data)}
        </span>
      );
    }
  },
  {
    title: "Причина",
    accessor: "reason"
  },
  {
    title: "Стоимость",
    accessor: "price"
  }
];

const summaryColumns = [
  {
    title: "Итого",
    colSpan: 4,
    className: "table__border-right"
  },

  {
    colSpan: 4,
    accessor: "money",
    renderCell: renderSummaryMoney
  }
];

const TeaserPayTable = ({ search, setDate }) => {
  const { sortBy, sortOrder, onSortChange } = useSort("date", "asc");
  const [state, setState] = useState({ result_price: 0, teasers: [] });
  const [loading, setLoading] = useState(false);
  const permissions = usePermissions();

  const summary = { money: state.result_price };

  useEffect(() => {
    if (canViewPayoutStatusAll(permissions) && !search.user) {
      return;
    }

    setLoading(true);

    TeasersPayoutsService(search)
      .then(data => {
        setState(data);
      })
      .catch(e => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [search]);

  return (
    <React.Fragment>
      <div className="page-pay__date-range">
        <DateSingle
          className="left"
          date={moment(search.date).toDate()}
          onChange={setDate}
        />
      </div>

      <Table
        columns={columns}
        data={state.teasers}
        summary={summary}
        summaryColumns={summaryColumns}
        sortBy={sortBy}
        sortOrder={sortOrder}
        onSortChange={onSortChange}
        className="buy"
        loading={loading}
      />
    </React.Fragment>
  );
};

export default TeaserPayTable;
